export default "__VITE_ASSET__BBrAfUDJ__"